<template>
  <v-col>
    <validation-provider v-slot="{ errors }" :rules="rules" :name="name">
      <v-autocomplete
        :items="fornecedoresSelecionados"
        :error-messages="errors"
        :value="value"
        :label="label"
        :prepend-icon="icon"
        :search-input.sync="search"
        item-text="trade_name"
        return-object
        :loading="calling"
        @input="$emit('input', $event)"
        @keyup.native="customChange($event, getFornecedorSearch)"
        no-filter
        :no-data-text="mensagemNoData"
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.trade_name"></v-list-item-title>
            <v-list-item-subtitle
              v-text="`CNPJ ${item.cnpj} - ${item.city} - ${item.district}`"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </validation-provider>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import { customChange } from '@/mixins/autocomplete.js'
import { mapActions } from 'vuex'

export default {
  name: 'RelatorioPerformanceRegiaoFiltroModalItemInputFornecedor',
  mixins: [customChange],
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      search: '',
      fornecedoresSelecionados: [],
    }
  },
  methods: {
    ...mapActions('fornecedores', ['getFornecedoresByParams']),
    async getFornecedorSearch(event) {
      const pesquisa = event.target.value
      try {
        const fornecedor = await this.getFornecedoresByParams({
          empresa: this.empresaAtual,
          params: {
            pesquisa,
          },
        })

        this.fornecedoresSelecionados = fornecedor
      } catch (error) {
        this.errorMessage('Erro ao carregar lista de fornecedores.')
        console.error(error)
      }
    },
  },
  computed: {
    ...mapState('auth', ['empresaAtual', 'user']),
    mensagemNoData() {
      if (this.calling) return 'Buscando...'
      if (this.search.length > 0) return 'Nenhum fornecedor encontrado'
      return 'Pesquise o Fornecedor'
    },
  },
  watch: {
    async search(search) {
      if (!search || search.length < 2) {
        this.fornecedoresSelecionados = []
      }
    },
  },
  async created() {
    if (this.value) {
      this.fornecedoresSelecionados = [this.value]
    }
  },
}
</script>
